export const Apostrophes = String.fromCharCode(8217);
